import { Project, Asset, SortType } from '@/types'


export type Mode = '916' | 'thumbnail' | 'list'

export type FolderState = {
  sortBy: SortType
  mode: Mode
  currentFolder: Asset | null
  currentProject: Project | null
  projects: Project[]
  assets: Asset[]
}

export const folderState: FolderState = {
  sortBy: 'name',
  mode: 'thumbnail',
  currentFolder: null,
  currentProject: null,
  projects: [],
  assets: [],
}
